import { IGetTimeFieldHelperTextProps } from './getTimeFieldHelperText.types';

export const getTimeFieldHelperText = (
  props: IGetTimeFieldHelperTextProps
): string | null | undefined => {
  const { isValidating, validatingText, hasError, errorText, hasSuccess, successText, helperText } =
    props;

  if (isValidating) {
    return validatingText;
  }

  if (hasError) {
    return errorText;
  }

  if (hasSuccess) {
    return successText;
  }

  if (helperText) {
    return helperText;
  }

  return null;
};
